import PhonePluse from "assets/images/phoneplus.svg";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { MdTableRows } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { setShowNavbar } from "redux/reducer/homeSlice";
import { notificationList } from "service/Auth";
import { getCustomerCare } from "service/customer";
import locationIcon from "../../../assets/images/locationIcon.svg";
import user from "../../../assets/images/userIcon.svg";
import NotificationBar from "../NotificationBar/NotificationBar";
import digi_mob from "assets/images/digigrainLogo.svg";
import "./header.scss";

const Header = () => {
  const userData = useSelector((state) => state.home.userDetails);
  const dispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);
  const [notification, setNotification] = useState([]);
  const [customerCareDetails, setCustomerCareDetails] = useState({});

  const getCustomerCareDetails = async () => {
    try {
      let params = {};
      const response = await getCustomerCare(params);
      if (response.status === 200) {
        setCustomerCareDetails(response?.data?.data);
      }
    } catch (e) {
      console.log("e", e);
    }
  };

  const getNotifications = async () => {
    try {
      const params = {
        returnAll: true,
        // isRead: true
      };
      const response = await notificationList(params);
      if (response.status === 200) {
        setNotification(response?.data?.data?.data);
      }
    } catch (e) {
      console.log("e", e);
    }
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  useEffect(() => {
    getCustomerCareDetails();
  }, []);

  useEffect(() => {
    let isMounted = true;
  
    if (localStorage.getItem("token")) {
      getNotifications();
    }
  
    const intervalId = setInterval(() => {
      if (isMounted) getNotifications();
    }, 30000);
  
    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <div className="top-bar position-relative pt-1 pb-2 px-2">
        <div className="userHeader px-2 px-md-0 py-md-3 py-lg-2 py-0 my-md-0">
          <div className="d-flex align-items-center">
            <MdTableRows
              size={20}
              className="d-block d-md-none"
              onClick={() => dispatch(setShowNavbar(true))}
            />
            <img src={digi_mob} width={100} className="mx-3" alt="" />
          </div>
          <div className="d-flex justify-content-end">
            <div className="d-none d-md-block">
              <div
                className="col px-2 "
                style={{ position: "absolute", left: "320px" }}
              >
                <div className="d-flex  dashboard_auth_name">
                  <div>
                    <p className="user_auth_name fw-700">{`Visit Website`}</p>
                    <span className="user_dashboard_role">
                      <a
                        href={`https://www.digigrain.in`}
                        target="_blank"
                        className=" fw-700 text-center text-plain"
                        rel="website"
                      >
                        {`www.digigrain.in`}
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {customerCareDetails?.mobileNumber &&
              String(userData?.role).toUpperCase() === "CUSTOMER" && (
                <div className="d-none d-md-block">
                  <div className="col px-2">
                    <div className="d-flex  dashboard_auth_name">
                      <div>
                        <p className="user_auth_name fw-700">
                          {customerCareDetails?.name}
                        </p>
                        <span className="user_dashboard_role ">
                          {customerCareDetails?.role}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            <div className="d-none d-md-block">
              <div className="col px-2 pt-2">
                {customerCareDetails?.mobileNumber &&
                  String(userData?.role).toUpperCase() === "CUSTOMER" && (
                    <div>
                      <p className="d-flex justify-content-start align-items-center mb-0">
                        <span className="px-1">
                          <img
                            src={PhonePluse}
                            alt={customerCareDetails?.mobileNumber}
                          />
                        </span>
                        <span className="">
                          {" "}
                          <a
                            href={`tel:${customerCareDetails?.mobileNumber}`}
                            // target="_blank"
                            className=" fw-700 text-center text-plain"
                          >
                            {customerCareDetails?.mobileNumber}
                          </a>
                        </span>
                      </p>
                      <p className="m-0 px-1" style={{ color: "#61903D" }}>
                        {" "}
                        Logged in as{" "}
                        {capitalizeFirstLetter(
                          String(userData?.role).toUpperCase()
                        )}
                      </p>
                    </div>
                  )}
              </div>
            </div>
            <div className="d-none d-md-block">
              <div className="col px-2 py-3">
                {customerCareDetails?.mobileNumber &&
                  String(userData?.role).toUpperCase() !== "CUSTOMER" && (
                    <div>
                      <p className="m-0" style={{ color: "#61903D" }}>
                        {" "}
                        Logged in as{" "}
                        {capitalizeFirstLetter(
                          String(userData?.role).toUpperCase()
                        )}
                      </p>
                    </div>
                  )}
              </div>
            </div>

            <div className="col  d-block">
              <Dropdown className="custom-dropdown d-flex align-items-center my-2">
                <div>
                  <img
                    src={locationIcon}
                    width={40}
                    className="mx-3 d-none d-md-block"
                    alt=""
                  />
                </div>
                <div>
                  <NotificationBar
                    showTooltip={showTooltip}
                    setShowTooltip={setShowTooltip}
                    onHide={() => setShowTooltip(false)}
                    notification={notification}
                    refresh={() => getNotifications()}
                  />
                </div>
                <Dropdown.Toggle id="dropdown-basic">
                  <Link to="/admin/myprofile">
                    <div>
                      <img
                        src={user}
                        width={40}
                        className="mx-md-3 mx-2 profile_icon"
                        alt=""
                      />
                    </div>
                  </Link>
                </Dropdown.Toggle>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end d-md-none logged_role">
        {customerCareDetails?.mobileNumber && (
            <div>
              <p className="m-0" style={{ color: "#61903D" }}>
                {" "}
                Logged in as{" "}
                {capitalizeFirstLetter(String(userData?.role).toUpperCase())}
              </p>
            </div>
          )}
      </div>
    </>
  );
};
export default Header;
